import React from 'react';
import styled from 'styled-components';
import { Input } from 'antd';
import { theme } from 'utils/style/theme';
const { TextArea } = Input;
/**
 * * 기본 textArea
 */

interface IProps {
  title?: string;
  id?: string;
  name?: string;
  value?: string;
  onChange?: (e) => void;
  placeholder?: string;
  disabled?: boolean;
  maxLength?: number;
  style?: React.CSSProperties;
  allowClear?: boolean;
  bottom?: string | boolean; // 하단에 더 이상 인풋(컴포넌트)가 없으니, 마진 주지마!
  noMarginBottom?: boolean; // 하단에 더 이상 인풋(컴포넌트)가 없으니, 마진 주지마!
  styleTextArea?: React.CSSProperties;
  hideLabel?: boolean;
  showCount?: boolean;
  minRows?: number;
}
const DefaultTextArea = ({
  title,
  id,
  name,
  value,
  style,
  onChange,
  maxLength,
  placeholder,
  allowClear,
  bottom,
  noMarginBottom = false,
  styleTextArea,
  hideLabel,
  showCount = true,
  minRows = 4,
}: IProps) => {
  return (
    <InputWrap style={style} bottom={bottom} noMarginBottom={noMarginBottom}>
      {!hideLabel && <label htmlFor={id}>{title}</label>}
      <TextAreaStyled
        id={id}
        name={name}
        value={value}
        allowClear={allowClear ? false : true} // allowClear만 props로 보내주면 false 처리
        showCount={showCount}
        // showCount={maxLength ? true : false}
        onChange={onChange}
        maxLength={maxLength}
        autoSize={{ minRows: minRows, maxRows: 8 }}
        placeholder={placeholder}
        style={styleTextArea}
      />
    </InputWrap>
  );
};

export default DefaultTextArea;
const InputWrap = styled.div`
  width: 100%;
  margin-bottom: ${(props) => (props.noMarginBottom ? '0' : '1.2rem')};
  label {
    color: ${theme.colors.blue_7};
    font-size: ${theme.fontSizes.md};
    margin-left: 0.3rem;
  }
`;

const TextAreaStyled = styled(TextArea)`
  /* width: 100%; */
  > textarea,
  .ant-input {
    border: 1px solid ${theme.colors.gray_5};
    border-radius: 0.4rem;
    /* 스크롤바 전체 */
    &::-webkit-scrollbar {
      width: 0.5rem;
    }
    /* 스크롤 막대 */
    &::-webkit-scrollbar-thumb {
      background-color: rgba(0, 0, 0, 0.1);
    }
    /* 스크롤 막대 외부 */
    &::-webkit-scrollbar-track {
      width: 0.6rem;
    }
  }
  &:after {
    font-size: 0.8rem;
    letter-spacing: -0.05rem;
  }
  &.ant-input-textarea {
    position: relative;
  }
  &.ant-input-textarea-show-count::after {
    background-color: transparent;
    position: absolute;
    bottom: 3px;
    z-index: 100;
    right: 12px;
  }
  &.ant-input-show-count-suffix {
  }
`;
